// bookingReducer.js

const initialState = {
    load: true
  };
  
  const gtmReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'GTM_LOAD':
        return {
            load:false
        };
      default:
        return state;
    }
  };
  
  export default gtmReducer;
  